export class Current_Section_Indicator {

    constructor( triggers, targets, options = {} ){

        if (typeof triggers === "string") {
            triggers = document.querySelectorAll(triggers);
        }
    
        if (typeof targets === "string") {
            targets = document.querySelectorAll(targets);
        }

        this.targets = targets;
        this.triggers = triggers;
        this.options = options;

        this.init();
    }

    init(){

        this.current = null;
        this.last_scroll_y = null;
        this.scroll_direction = "down";
        this.navigating = false;

        this.observer_down = new IntersectionObserver((entries, observer)=>{
            this.down_callback( entries, observer );
        }, {});

        this.observer_up = new IntersectionObserver((entries, observer)=>{
            this.up_callback( entries, observer );
        },{
            threshold: 0.5,
        });

        this.triggers.forEach((trigger, index) => {
            trigger.el_target = this.targets[index];
            trigger.el_target.el_trigger = trigger;
            this.observer_down.observe(trigger);
            this.observer_up.observe(trigger);
        });

        this.activate(this.triggers[0]);
    }

    down_callback( entries, observer ) {

        if ( this.navigating ) return;

        if (this.last_scroll_y === null) {
			// on load
			this.last_scroll_y = window.scrollY;
			return;
		}

		this.scroll_direction = window.scrollY > this.last_scroll_y ? "down" : "up";
		this.last_scroll_y = window.scrollY;

		if ( this.scroll_direction != "down" ) return;

		for (let i = 0; i < entries.length; i++) {
			let item = entries[i];
			if (!item.isIntersecting) {
				// this.activate(item.target);
				this.activate(item.target.nextElementSibling);
				break;
			}
		}
    }

    up_callback( entries, observer ) {
        if ( this.navigating ) return;
		if ( this.scroll_direction != "up" ) return;
		for (let i = 0; i < entries.length; i++) {
			let item = entries[i];
			if (item.isIntersecting) {
				this.activate(item.target);
				break;
			}
		}
	};

	activate( element ) {

        if( !element || typeof element.el_target === 'undefined' ) return;

		this.deactivate_previous();
		this.current = element;
		this.current.classList.add("v_current");
		this.current.el_target.classList.add("v_current");
	}

	deactivate_previous() {
		if (!this.current) return;
		this.current.classList.remove("v_current");
		this.current.el_target.classList.remove("v_current");
	}

    navigate( element ){
        this.navigating = true;
        this.activate( element );
    }

    navigate_complete(){
        this.navigating = false;
    }
}